export default __webpack_public_path__ + "static/media/FranticVelvet.79edde5d.jpg";